import { useTranslation } from 'next-i18next'
import React from 'react'

import { URL_INSTAGRAM, URL_TWITTER } from '@goodfellas/environment'

import s from './landing.module.css'

/** Telefone da home — mesmo número do rodapé institucional. */
const SUPPORT_PHONE_DISPLAY = '+55 11 5028-7668'
const SUPPORT_PHONE_HREF = 'tel:+551150287668'

/** Ícone de telefone (inline) para o botão de ligação. */
function PhoneGlyph() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.9.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z" />
    </svg>
  )
}

const CHANNEL_TITLE: React.CSSProperties = {
  fontSize: 'clamp(30px,3vw,44px)',
  margin: '12px 0 6px',
  color: '#fff',
}

const CHANNEL_COPY: React.CSSProperties = { color: 'rgba(255,255,255,.75)' }

/**
 * Suporte — canais de contato para tirar dúvidas: Instagram, X e o telefone
 * da home como botão de ligação direta ("em caso de dúvidas").
 */
export function Support() {
  const { t } = useTranslation('landing')

  return (
    <section
      className={`bg-section-black ${s.sec}`}
      id="suporte"
      style={{ position: 'relative', overflow: 'hidden' }}
    >
      <p className={`${s.kick} text-brand`}>
        <span className={s.kbar} />
        {t('support.kicker')}
      </p>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 24,
          alignItems: 'flex-end',
          marginTop: 22,
        }}
      >
        <h2 className={`${s.d} ${s.h2} text-white`} style={{ margin: 0 }}>
          {t('support.title1')}
          <br />
          <span className={s.outW}>{t('support.title2')}</span>
        </h2>
        <p
          className={s.lead}
          style={{ maxWidth: 440, color: 'rgba(255,255,255,.85)' }}
        >
          {t('support.lead')}
        </p>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit,minmax(280px,1fr))',
          gap: 20,
          marginTop: 44,
        }}
      >
        {/* Telefone da home — botão para ligar em caso de dúvidas. */}
        <div className={s.mediacard} style={{ borderColor: '#EC1B2E' }}>
          <div className={s.stag}>{t('support.phoneTag')}</div>
          <div className={s.d} style={CHANNEL_TITLE}>
            {SUPPORT_PHONE_DISPLAY}
          </div>
          <p className={s.fp} style={CHANNEL_COPY}>
            {t('support.phoneCopy')}
          </p>
          <a
            href={SUPPORT_PHONE_HREF}
            className={`${s.btn} ${s.btnR}`}
            style={{ marginTop: 22 }}
          >
            <PhoneGlyph />
            {t('support.call')}
          </a>
        </div>

        {/* Instagram */}
        <a
          className={s.mediacard}
          href={URL_INSTAGRAM}
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className={s.stag}>Instagram · @goodfellasapp</div>
          <div className={s.d} style={CHANNEL_TITLE}>
            Instagram
          </div>
          <p className={s.fp} style={CHANNEL_COPY}>
            {t('support.instagramCopy')}
          </p>
          <div className={s.playrow}>{t('support.follow')}</div>
        </a>

        {/* X (antigo Twitter) */}
        <a
          className={s.mediacard}
          href={URL_TWITTER}
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className={s.stag}>X · @goodfellas_app</div>
          <div className={s.d} style={CHANNEL_TITLE}>
            X
          </div>
          <p className={s.fp} style={CHANNEL_COPY}>
            {t('support.xCopy')}
          </p>
          <div className={s.playrow}>{t('support.follow')}</div>
        </a>
      </div>
    </section>
  )
}
